import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { FullPageLoader } from './LoadingSpinner';
import Layout from './Layout';

const ProtectedRoute = ({ children, requiredRoles = [] }) => {
  const { t } = useTranslation();
  const { user, loading, hasPermission } = useAuth();
  const location = useLocation();

  if (loading) {
    return <FullPageLoader message={t('common.loading')} />;
  }

  if (!user) {
    // Redirect to login page with return url
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredRoles.length > 0 && !hasPermission(requiredRoles)) {
    // User doesn't have required permissions
    return (
      <Layout>
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">
              {t('common.accessDeniedTitle')}
            </h1>
            <p className="text-gray-600">{t('common.accessDeniedMessage')}</p>
          </div>
        </div>
      </Layout>
    );
  }

  return <Layout>{children}</Layout>;
};

export default ProtectedRoute;